module.exports = "https://cdn-challenge.mathletics.com/app/111/assets/images/4a2d23f616025a35dff87fbc62f052db.svg";